<script lang="ts">
	import Empty from './svg/Empty.svelte';

	import { _ } from 'svelte-i18n';
</script>

<div class="header">
	<h2>{$_('post.activity.latest.heading')}</h2>
</div>
<p>{$_('post.activity.none.available')}</p>
<Empty />
<p>{$_('post.activity.none.available.notify')}</p>

<style>
	h2 {
		margin: 0;
		font-size: var(--fontSizeSmall);
		font-weight: bold;
	}

	p {
		display: flex;
		justify-content: center;
		margin-block-end: var(--gutterLarge);
		font-size: var(--fontSizeSmaller);
	}

	.header {
		padding: var(--gutterMedium);
	}
</style>
